import React from 'react';
import { translate } from 'react-i18next';

import Logout from '../common/Logout';
import NoAccess from '../img/no-access.gif';

const Render = ({ t, isLoading, error, render }) => {
  // If nothing is going on (null), display the loading anyways.
  if (isLoading || isLoading === null) {
    return (
      <p className="u-text-center u-margin-vertical">{t('general.loading')}</p>
    );
  }

  if (error) {
    return (
      <div className="c-alert c-alert--danger u-margin-top">
        <p>
          {t('general.error')}
          <br />
          {error.message}
        </p>
        {error.statusCode === 401 && (
          <div>
            <p>
              <img src={NoAccess} alt="No Access" />
            </p>
            <p className="u-margin-bottom-none">{t('expiredTokenTrick')}</p>
            <Logout title={t('general.okay')} />
          </div>
        )}
      </div>
    );
  }

  return render();
};

export default translate()(Render);



// WEBPACK FOOTER //
// ./src/common/Render.js